import api from "./api";

// Load articles cache from localStorage or initialize if not present
const loadArticlesCache = () => {
    const cache = localStorage.getItem('articleCache');
    return cache ? JSON.parse(cache) : {};
};

const articleCache = loadArticlesCache();

const saveArticlesCache = () => {
    localStorage.setItem('articleCache', JSON.stringify(articleCache));
};

export const createArticle = async ({ title, body, metaTags, imageURL, notify }) => {
    const response = await api.post("/articles", {
        title,
        body,
        metaTags,
        imageURL,
        notify
    });
    clearArticlesCache(); // Invalidate cache upon creation
    return response;
};

export const getArticles = async (query = {}) => {
    const cacheKey = JSON.stringify(query); // Simple serialization of query params
    const currentTime = Date.now();
    const cacheExpiry = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    // Check if cached data exists and is not expired
    if (articleCache[cacheKey] && (currentTime - articleCache[cacheKey].timestamp) < cacheExpiry) {
        return articleCache[cacheKey].data;
    }

    // Fetch new data if no valid cache is found
    const response = await api.get("/articles", { params: query });
    const articleList = response.data;

    // Update the cache with new data and save it to localStorage
    articleCache[cacheKey] = {
        timestamp: Date.now(),
        data: {
            articles: articleList
        }
    };
    saveArticlesCache();

    return articleCache[cacheKey].data;
};

export const updateArticle = async ({ articleId, title, body, metaTags, imageURL }) => {
    const result = await api.put(`/articles/${articleId}`, {
        title,
        body,
        metaTags,
        imageURL
    });
    // Invalidate the cache here by clearing it or specific entries if applicable
    clearArticlesCache();
    return result;
};

export const deleteArticle = async (articleId) => {
    const result = await api.delete(`/articles/${articleId}`);
    // Invalidate the cache here by clearing it or specific entries if applicable
    clearArticlesCache();
    return result;
};

// Utility function to clear the articles cache and update localStorage
export const clearArticlesCache = () => {
    Object.keys(articleCache).forEach(key => {
        delete articleCache[key];
    });
    saveArticlesCache(); // Reflect changes in localStorage
};
